<template>
  <div :class="className">
    <label class="block mb-3">
      {{ label }} <span v-if="required" class="text-red-500">*</span>
    </label>
    <div class="flex gap-6">
      <label
        v-for="option in options"
        :key="option.value"
        class="flex items-center gap-3 cursor-pointer group"
      >
        <div class="relative">
          <input
            type="radio"
            :name="`radio-${label}`"
            :value="option.value"
            :checked="modelValue === option.value"
            @change="$emit('update:modelValue', option.value)"
            class="sr-only"
          />
          <div :class="[
            'w-5 h-5 rounded-full border-2 transition-all duration-200',
            modelValue === option.value
              ? 'border-blue-600 bg-blue-600'
              : 'border-gray-300 bg-white group-hover:border-blue-400'
          ]">
            <div
              v-if="modelValue === option.value"
              class="w-full h-full rounded-full bg-white scale-[0.4] transition-transform duration-200"
            ></div>
          </div>
        </div>
        <span :class="[
          'transition-colors duration-200',
          modelValue === option.value 
            ? 'text-gray-900' 
            : 'text-gray-600 group-hover:text-gray-800'
        ]" style="font-size: var(--text-base); font-weight: var(--font-weight-medium); line-height: 1.5;">
          {{ option.label }}
        </span>
      </label>
    </div>
  </div>
</template>

<script setup>
// 定义选项类型
defineProps({
  label: {
    type: String,
    required: true
  },
  options: {
    type: Array,
    required: true
  },
  modelValue: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  },
  className: {
    type: String,
    default: ''
  }
})

defineEmits(['update:modelValue'])
</script>

<style scoped>

</style>